export const menuItems = [
  {
    id: 1,
    label: 'menuitems.myinventory.all',
    icon: 'fas fa-boxes',
    alwaysExpanded: true,
    subItems: [
      {
        id: 10,
        parentId: 1,
        label: 'general.all',
        link: '/inventory',
      },
      {
        id: 11,
        parentId: 1,
        label: 'categories.types.panels',
        link: '/inventory/01CB1358-9AF3-4C81-AEEE-D1488C12156B',
      },
      {
        id: 12,
        parentId: 1,
        label: 'categories.types.products',
        link: '/inventory/02E24169-7171-4570-BC3E-F01541D3C341',
      },
      {
        id: 13,
        parentId: 1,
        label: 'categories.types.detached',
        link: '/inventory/02FCAA03-11E2-4CA5-9026-339EB9572CC0',
      },
      {
        id: 14,
        parentId: 1,
        label: 'categories.types.edgebands',
        link: '/inventory/03103388-EAD4-463C-8329-E1044826C56E',
      },
      {
        id: 15,
        parentId: 1,
        label: 'categories.types.hardwares',
        link: '/inventory/040811DA-D23A-403B-B17E-FEEA78A0D650',
      },
      {
        id: 16,
        parentId: 1,
        label: 'categories.types.drawers',
        link: '/inventory/05DEDB5D-82F3-4506-9E95-ED931B79730A',
      },
      {
        id: 17,
        parentId: 1,
        label: 'categories.types.doors',
        link: '/inventory/06EEAD67-1480-4D47-9A00-936EF12BF856',
      },
      {
        id: 17,
        parentId: 1,
        label: 'categories.types.moldings',
        link: '/inventory/07A2930F-737B-4D89-A2DD-AEE7C2B5B0CD',
      },
      {
        id: 19,
        parentId: 1,
        label: 'categories.types.others',
        link: '/inventory/078019BD-FA78-41AA-ACDF-BF1FF508E2F6',
      },
    ],
  },
  {
    id: 2,
    label: 'menuitems.myinventory.management',
    icon: 'bx bx-desktop',
    alwaysExpanded: true,
    subItems: [
      {
        id: 21,
        parentId: 2,
        label: 'menuitems.myinventory.items',
        link: '/inventory/requests',
        alertsCode: 'CriticalItemsCount',
        role: 'hasInventoryAccess',
      },
      {
        id: 22,
        parentId: 2,
        label: 'menuitems.myinventory.workOrders',
        link: '/workorders',
        role: 'hasWorkOrdersAccess',
        alertsCode: 'ActionNeededWorkOrdersCount',
      },
      {
        id: 23,
        parentId: 2,
        label: 'menuitems.myinventory.shoppingCart',
        link: '/cart',
        role: 'hasShoppingCartAccess',
        alertsCode: 'ItemsRequestsCount',
      },
      {
        id: 24,
        parentId: 2,
        label: 'menuitems.myinventory.orders',
        link: '/orders',
        role: 'hasOrdersAccess',
        alertsCode: 'ToOrderCount',
      },
      {
        id: 25,
        parentId: 2,
        label: 'menuitems.myinventory.receptions',
        link: '/receptions',
        role: 'hasReceptionsAccess',
      },
    ],
  },
  {
    id: 4,
    label: 'menuitems.myinventory.dashboards.dashboards',
    role: 'hasDashboardsAccess',
    icon: 'bx bx-stats',
    subItems: [
      {
        id: 41,
        label: 'menuitems.myinventory.dashboards.prices',
        link: '/dashboards/prices',
        parentId: 4,
      },
      {
        id: 42,
        label: 'menuitems.myinventory.dashboards.priceHistories',
        link: '/dashboards/pricehistories',
        parentId: 4,
      },
    ],
  },
  {
    id: 5,
    label: 'menuitems.configuration.text',
    role: 'hasConfigAccess',
    icon: 'bx bx-cog',
    adminAccess: true,
    subItems: [
      {
        id: 51,
        label: 'menuitems.configuration.list.users',
        link: '/configuration/users',
        adminOnly: true,
        parentId: 5,
      },
      {
        id: 52,
        label: 'menuitems.configuration.list.organization',
        link: '/configuration/organization',
        adminOnly: true,
        parentId: 5,
      },
      {
        id: 53,
        label: 'menuitems.configuration.list.items',
        link: '/configuration/items',
        parentId: 5,
      },
      {
        id: 54,
        label: 'menuitems.configuration.list.orders',
        link: '/configuration/orders',
        adminOnly: true,
        parentId: 5,
      },
      {
        id: 55,
        label: 'menuitems.configuration.list.suppliers',
        link: '/configuration/suppliers',
        parentId: 5,
      },
      {
        id: 56,
        label: 'menuitems.configuration.list.categorytypes',
        link: '/configuration/categorytypes',
        parentId: 50,
      },
      {
        id: 57,
        label: 'menuitems.configuration.list.categories',
        link: '/configuration/categories',
        parentId: 5,
      },
      {
        id: 58,
        label: 'menuitems.configuration.list.allocationgroups',
        link: '/configuration/allocationgroups',
        parentId: 50,
      },
      {
        id: 59,
        label: 'menuitems.configuration.list.allocations',
        link: '/configuration/allocations',
        parentId: 50,
      },
      {
        id: 60,
        label: 'menuitems.configuration.list.importations',
        link: '/configuration/importations',
        parentId: 5,
      },
    ],
  },
];
